import useMutationApi from 'src/api/useMutationApi';

const useRejectSalesOrderDraft = (
  salesOrderDraftId: string,
  onSuccess?: () => void,
) => {
  return useMutationApi<void>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/reject`,
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useRejectSalesOrderDraft;
